module.exports = __webpack_public_path__ + "img/AngryButterfly.94299807.jpg";